import { SectionData } from '@playbooks/action-cards-utils/src'
import { useTranslation } from '../contexts/localization/Localization'
import { cn } from '@playbooks/ui/lib/utils'
import Sections from './Sections'

export default function PinnedSections({
  sections,
  enabled,
  isRight,
}: {
  sections: SectionData[]
  enabled: boolean
  isRight: boolean
}) {
  const { text } = useTranslation()

  return enabled ? (
    <div
      id="AC_pinContainer"
      data-role="data-action-cards-sides-scroll-container"
      className={cn('w-full h-full overflow-auto scroll-smooth pb-25', isRight ? 'pr-2' : 'pl-2')}
    >
      {sections.length ? (
        <Sections sections={sections} isPinnedView />
      ) : (
        <div className={'text-center text-zinc-500 text-[12px]'}>{text('noPinnedSections')}</div>
      )}
    </div>
  ) : null
}
